var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilValue } from 'recoil';
import { useInputAttributes } from '@/hooks/useInputAttributes';
import { themeSelector } from '@/state/config';
import styles from './Input.module.scss';
export const Input = (_a) => {
    var { label, required, register, error, isDirty, defaultValue, name = '', type = 'text' } = _a, rest = __rest(_a, ["label", "required", "register", "error", "isDirty", "defaultValue", "name", "type"]);
    const theme = useRecoilValue(themeSelector);
    const { extraAttributes } = useInputAttributes();
    return (_jsxs("div", { className: cn(styles.container, styles[theme]), children: [_jsxs("div", { className: cn(styles.inputContainer, {
                    [styles.required]: required,
                    [styles.error]: error,
                }), children: [_jsx("input", Object.assign({}, rest, { name: name, className: cn(styles.input, {
                            [styles.dirty]: isDirty,
                        }), type: type }, register, { defaultValue: defaultValue }, extraAttributes)), _jsx("span", { className: styles.label, children: label })] }), error && _jsx("p", { className: styles.errorMessage, children: error })] }));
};
